module.exports = __webpack_public_path__ + "static/media/Icons_Idle_05_Shield.a7453683.svg";